<template>
	<Modal @close="$emit('close')" class="publish-board" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<img src="../../../assets/images/logo-robo.png" alt="Riding out board online">
					<h1>Publish Board</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-8 offset-2 publish-info">
					<p><strong>URL: </strong> <a :href="viewUrl" target="_blank">{{ viewUrl }}</a></p>
					<p><strong>PIN: </strong> {{ account.tenant.pin }} <router-link to="/account" class="change">Change pin</router-link></p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<button class="button-action button-submit" @click="$emit('publish')">PUBLISH BOARD</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import { mapState } from 'vuex'

export default {
  components: {
		Modal
	},
	computed: {
		...mapState({
			tenant: state => state.tenant,
			account: state => state.account
		}),
		viewUrl() {
			return `${ window.location.protocol }//${ window.location.hostname }/view/${ this.account.tenant.url}`
		}
	}
}
</script>

<style lang="scss">
.publish-board  {
	img {
		border-radius: 10px;
		height: 200px;
		width: 200px;
		box-shadow: 0 0 34px 0 rgba(0,0,0,0.15);
	}
	a, a:hover, a:focus, a:visited {
		color: #0C2D39
	}
	a.change, a.change:hover, a.change:focus, a.change:visited {
		color: #009487
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Board/Publish.vue